module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box",
    class: {
      'plr15': !_vm.data.fullWidth, 'mb15': !_vm.data.hideBottomGap
    },
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "image-banner-box"
  }, [(_vm.swiper) ? _c('div', {
    staticClass: "images"
  }, [_c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": _vm.paginateCls,
      "showPaginate": _vm.showPaginate
    }
  }, _vm._l((_vm.items), function(item, index) {
    return (item.image.src) ? _c('div', {
      staticClass: "swiper-slide",
      on: {
        "click": function($event) {
          return _vm.imageAction(item, index)
        }
      }
    }, [_c('beastImage', {
      attrs: {
        "src": _vm.ensureImage(item.image.src)
      }
    })], 1) : _vm._e()
  }), 0)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5169e02d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/image-banner.vue
// module id = 634
// module chunks = 1 13